module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_aqua_black-6e53a8e5b7436d4b16db7b900a7766e9.svg";